export default __webpack_public_path__ + "static/media/bt4dg512-logo_D1.636a9c04.png";